<template>
  <div 
    class="form-element"
    :class="{ '-disabled': isPassive, '-nomargin': isMinimal }"
  >
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <div class="form-element__select">
      <div
        class="form-element__select__default "
        :class="classObjectOne"
        :data-exclude="true"
        @click="open()"
      >
        {{ text }}
      </div>
      <div
        class="form-element__select__list"
        :class="classObjectTwo"
        v-click-outside="outside"
        v-if="isOpen"
      >
        <form-search v-model="search" />
        <div
          class="form-element__select__item"
          :class="{ '-selected': item.name == text }"
          v-for="item in filteredList"
          :key="`option-${item.id}`"
          @click="selectThis(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="form-element__message" v-if="message">{{ message }}</div>
    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message2"
      style="color:red"
    >
      {{ message2 }}
    </div>
  </div>
</template>

<script>
import { clickOutside } from "@/directives/";
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    list: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    isPassive: {
      type: Boolean,
      default: false,
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    isQuarter: {
      type: Boolean,
      default: false,
    },
    isMinimal: {
      type: Boolean,
      default: false,
    },
    isDay: {
      type: Boolean,
      default: false,
    },
    isMonth: {
      type: Boolean,
      default: false,
    },
    noShadow: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Seçiniz",
    },
    isError:{
      type: Boolean,
      default: false,
    },
    message2: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selected: this.value,
      isOpen: false,
      search: "",
    };
  },
  directives: {
    "click-outside": clickOutside,
  },
  watch: {
    value: function (val) {
      this.selected = val;
    },
  },
  computed: {
    text: function () {
      return this.selected ? this.selected : this.placeholder;
    },
    filteredList() {
      return this.list.filter((item) => {
        return item.name
          .toLocaleLowerCase()
          .includes(this.search.toLocaleLowerCase());
      });
    },
    classObjectOne: function () {
      let list = {
        "-disabled": this.isPassive,
        "-selected": this.selected,
        "-half": this.isHalf,
        "-quarter": this.isQuarter,
        "-minimal": this.isMinimal,
        "-noshadow": this.noShadow,
        "-day": this.isDay,
        "-month": this.isMonth,
        // "-error":this.isError
        "-SelectError":this.isError
      };

      return list;
    },
    classObjectTwo: function () {
      let list = {
        "-half": this.isHalf,
        "-quarter": this.isQuarter,
        "-minimal": this.isMinimal,
        "-day": this.isDay,
        "-month": this.isMonth,
        "-noscroll": this.filteredList.length < 8,
      };

      return list;
    },
  },
  methods: {
    selectThis: function (item) {
      let vm = this;

      let isSameSelected = vm.selected == item.name;

      vm.selected = isSameSelected ? null : item.name;

      vm.$emit("input", vm.selected);

      vm.isOpen = false;
      vm.search = "";

      return;
    },
    open: function () {
      let vm = this;

      if (vm.isPassive) return;

      vm.isOpen = !vm.isOpen;
    },
    outside: function () {
      this.isOpen = false;
    },
  },
};
</script>